// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"BenifitsOfTeaching_itemContainer__J_yUq","imgcontainer":"BenifitsOfTeaching_imgcontainer__e5b_y"};